import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=e4731dd0&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=e4731dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4731dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4731dd0')) {
      api.createRecord('e4731dd0', component.options)
    } else {
      api.reload('e4731dd0', component.options)
    }
    module.hot.accept("./Welcome.vue?vue&type=template&id=e4731dd0&scoped=true&", function () {
      api.rerender('e4731dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Welcome.vue"
export default component.exports